import React from 'react';
import { Alert, CircularProgress, Typography } from '@mui/material';
import { getYearlyUpgradeSubscriptionDateString } from './helper';

const NewSubscriptionDateText = (
  <Alert severity="info" sx={{ mt: '10px' }}>
    <Typography variant="body2">{getYearlyUpgradeSubscriptionDateString()}</Typography>
  </Alert>
);

const CircularProgressInText = (
  <CircularProgress
    size={16}
    sx={{ marginLeft: '2px', marginRight: '2px', transform: 'translateY(4px)' }}
  />
);

export { NewSubscriptionDateText, CircularProgressInText };
